import React from "react";
import ModalWr from "./ModalWr";

// const ModalKoinot = ({ display, content, callback }) => {
//   return (
//     <ModalWr className={`modal ${display}`}>
//       <div className="modal-dialog">
//         <div className="modal-content">
//           <div className="modal-body">
//             <h4>{content}</h4>
//           </div>
//           <div className="modal-footer ">
//             {isConfirm ? (
//               <div className="d-flex justify-content-evenly align-items-center w-100">
//                 <button
//                   type="button"
//                   className="btn btn-success"
//                   onClick={() => confirmRes(true)}
//                 >
//                   Ha
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger"
//                   onClick={() => confirmRes(false)}
//                 >
//                   Yo'q
//                 </button>
//               </div>
//             ) : (
//               <button
//                 type="button"
//                 className="btn"
//                 onClick={() => callback("d-none")}
//               >
//                 Close
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </ModalWr>
//   );
// };

const ModalKoinot = ({ display, content, callback }) => {
  return (
    <ModalWr className={`modal ${display}`}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <h4>{content}</h4>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn"
              onClick={() => callback("d-none")}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </ModalWr>
  );
};

export default ModalKoinot;



// WEBPACK FOOTER //
// ./src/Components/Modal/index.js